import { c as _c } from "react/compiler-runtime";
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
interface ContentsListItemProps {
  imageUrl: string;
  title: string;
  summary: string;
  href: string;
  priority?: boolean;
}
export const ContentsListItem = t0 => {
  const $ = _c(13);
  const {
    imageUrl,
    title,
    summary,
    href,
    priority: t1
  } = t0;
  const priority = t1 === undefined ? false : t1;
  const t2 = imageUrl || "/images/placeholder.png";
  const t3 = title || "\uCF58\uD150\uCE20 \uC774\uBBF8\uC9C0";
  let t4;
  if ($[0] !== priority || $[1] !== t2 || $[2] !== t3) {
    t4 = <div className="relative mb-24 aspect-[335/223] w-full overflow-hidden rounded-large"><Image src={t2} alt={t3} fill={true} sizes="(max-width: 768px) 100vw, 335px" className="object-cover" preload={priority} /></div>;
    $[0] = priority;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== title) {
    t5 = <div className="mb-12 flex justify-between"><p className="line-clamp-2 overflow-hidden text-ellipsis whitespace-normal font-700 text-Gray-black typo-body2">{title}</p></div>;
    $[4] = title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = summary || "\uB0B4\uC6A9\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.";
  let t7;
  if ($[6] !== t6) {
    t7 = <p className="line-clamp-2 overflow-hidden text-ellipsis whitespace-normal font-400 text-Gray-600 typo-body4">{t6}</p>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== href || $[9] !== t4 || $[10] !== t5 || $[11] !== t7) {
    t8 = <CustomLink href={href}>{t4}{t5}{t7}</CustomLink>;
    $[8] = href;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};